module.exports = __webpack_public_path__ + "img/img (21).f83b12b6.jpg";